import { PureComponent } from 'react';
import clsx from 'clsx';

interface Props {
  contextClassName?: string;
  modifierClassName?: string;
  text?: string;
  'data-testid'?: string;
}

export default class Spinner extends PureComponent<Props> {
  static defaultProps: Partial<Props> = {
    modifierClassName: 'Spinner--default',
  };

  render() {
    const { contextClassName, modifierClassName, text } = this.props;
    const className = clsx('Spinner', modifierClassName);

    return (
      <div className={contextClassName} data-testid={this.props['data-testid']}>
        <div className={className}>
          <div className="Spinner-body">
            <div className="Spinner-animation" />

            {text && <span className="Spinner-text">{text}</span>}
          </div>
        </div>
      </div>
    );
  }
}
